import { MenuCategoryCreateDto, MenuCategoryUpdateDto } from "../../../api";
import {CrudFormItemProps, CrudFormModal, nameof} from "digimuth-components/dist";

const formItems: CrudFormItemProps[] = [
     {
         name: nameof<MenuCategoryCreateDto>("name"),
         rules: [
             {required: true, message: 'To pole jest wymagane'}
         ],
         label:"Nazwa"
     },
];

export default function MenuCategoryModalForm(props: MenuCategoryModalProps) {
    return <CrudFormModal
        formItems={formItems}
        forceRender={true}
        destroyOnClose={true}
        onSubmit={props.onSubmit}
        onModalCancelClicked={() => props.setModalVisibility(false)}
        initialValues={props.initialValues}
        modalOkText={props.saveButtonTitle}
        modalCancelText={props.cancelButtonTitle}
        modalTitle={props.modalTitle}
        isModalVisible={props.isModalVisible}
    />;
}

interface MenuCategoryModalProps {
    initialValues?: MenuCategoryCreateDto | MenuCategoryUpdateDto,
    isModalVisible: boolean;
    setModalVisibility: (isVisible: boolean) => any;
    onSubmit: (value: MenuCategoryCreateDto | MenuCategoryUpdateDto) => Promise<any>,
    modalTitle: string,
    saveButtonTitle: string,
    cancelButtonTitle: string,
}
